module.exports = __webpack_public_path__ + "img/page_image_2_8.eef8529f.svg";